import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Guards delivery-partner routes.
 * - Not logged in as a partner -> redirect to /delivery/login
 * - Logged in but not approved   -> redirect to /delivery/login
 *
 * UI-level guard only; the backend also verifies role + approval.
 */
function DeliveryRoute({ children }) {
  let info = null;

  try {
    info = JSON.parse(localStorage.getItem('deliveryInfo'));
  } catch (e) {
    info = null;
  }

  if (!info || info.role !== 'delivery' || !info.isApproved) {
    return <Navigate to="/delivery/login" replace />;
  }

  return children;
}

export default DeliveryRoute;
